import {Trans} from 'react-i18next';

export interface SpecsProps {
  specs: Array<{
    key: string;
    value: string[];
  }>;
}

export function Specs({specs}: SpecsProps) {
  return (
    <div className="overflow-auto px-5 md:px-10 scrollbar-hide">
      <table className="w-full">
        <tbody>
          {specs.map((s) => {
            const name = `pages:producto:${s.key}`;

            return (
              <tr key={s.key}>
                <th
                  className="pr-1 pb-1"
                  style={{
                    width: '1%',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span className="block py-1 px-4 w-full text-sm font-normal text-left text-white bg-blue-600 rounded-full">
                    <Trans i18nKey={name} />
                  </span>
                </th>
                {s.value.map((v, i) => {
                  return (
                    <td className="pr-1 pb-1 last:pr-0" key={i}>
                      <span
                        className="block py-1 px-4 w-full text-sm text-left bg-gray-100 rounded-full"
                        style={{
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {v}
                      </span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
